import { useState } from "react";
import { CalendarClock, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

export function RescheduleDialog({ night, open, onOpenChange, onConfirm, busy }) {
  const [date, setDate] = useState(night?.date || "");
  const today = new Date().toISOString().split("T")[0];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-md" data-testid="reschedule-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold flex items-center gap-2">
            <CalendarClock size={20} className="neon-cyan" /> Reschedule night
          </DialogTitle>
          <DialogDescription>
            Pick a new date for {night?.city}. We'll keep your dinner and drinks spots and find a live
            event happening that night.
          </DialogDescription>
        </DialogHeader>
        <Input
          data-testid="reschedule-date-input"
          type="date"
          min={today}
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="h-12 rounded-xl"
        />
        <DialogFooter>
          <Button variant="ghost" className="rounded-full" onClick={() => onOpenChange(false)} data-testid="reschedule-cancel-btn">
            Cancel
          </Button>
          <Button
            data-testid="reschedule-confirm-btn"
            disabled={!date || date === night?.date || busy}
            onClick={() => onConfirm(date)}
            className="rounded-full cta-gradient text-white font-semibold"
          >
            {busy ? <Loader2 size={16} className="mr-2 animate-spin" /> : null}
            {busy ? "Refreshing event…" : "Move night"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
